import { ReactNode, useContext, useMemo } from "react";
import { AppContext } from "context/appContext";
import { Outlet, useNavigation } from "react-router";
import { useTranslation } from "react-i18next";
import FormTabNavigation, {
  FormTab,
} from "components/layout/FormTabNavigation";
import { ROUTES, routeWithParams } from "router/routes";
import { Box } from "@mui/material";
import FormHeaderBar from "components/layout/FormHeaderBar";
import FormFrame from "components/layout/FormFrame";

const ReportsPanel = (): ReactNode => {
  const { t } = useTranslation();
  const { state } = useContext(AppContext);
  const navigation = useNavigation();

  const tabs: FormTab[] = useMemo(() => {
    const tabs: FormTab[] = [];
    if (state.entityPermissions.property.read) {
      tabs.push({
        label: `${t("reports.jobsByProperty")}`,
        route: routeWithParams(ROUTES.REPORTS_JOBS_BY_PROPERTY, [
          state.tenant.id,
        ]),
        beforeNavigate: () => {
          return true;
        },
      });
    }

    return tabs;
  }, []);

  return (
    <Box
      flexGrow={1}
      display={"flex"}
      flexDirection={"column"}
      minHeight={0}
      sx={{
        overflow: "hidden",
      }}
    >
      <FormHeaderBar />
      <FormTabNavigation tabs={tabs} title={t("reports.title")} />
      <FormFrame loading={navigation.state === "loading"}>
        <Outlet />
      </FormFrame>
    </Box>
  );
};

ReportsPanel.displayName = "ReportsPanel";
export default ReportsPanel;
